export default function tabs() {
  // add select functionality, simulate click
  const selectEl = document.querySelector('.js-tab-select');

  if (selectEl) {
    selectEl.addEventListener('change', () => {
      document.querySelector(`.js-tab-selector[data-tab-id="${selectEl.value}"]`).click();
    });
  }

  function setTabActive(
    tabSelector,
    tabSelectors,
    linkedTab,
    allTabs,
    allTabSelectorImages,
    linkedTabSelectorImage,
    tabId,
  ) {
    tabSelectors.forEach(element => {
      element.classList.remove('active');
    });
    if (linkedTab) {
      tabSelector.classList.add('active');
      allTabs.forEach(element => {
        element.classList.add('hide');
      });
      /*   linkedTab.forEach(element => {
        element.classList.remove('hide');
      });  */

      linkedTab.classList.remove('hide');
    }
    if (linkedTabSelectorImage) {
      allTabSelectorImages.forEach(element => {
        element.classList.add('hide');
      });
      /*  linkedTabSelectorImage.forEach(element => {
        element.classList.remove('hide');
      }); */

      linkedTabSelectorImage.classList.remove('hide');
    }
    if (tabId && !window.modalManager.activeModal) {
      window.location.hash = tabId;
    }
  }

  [...document.querySelectorAll('.js-tabs-wrapper')].forEach(tabsWrapper => {
    const tabSelectors = tabsWrapper.querySelectorAll('.js-tab-selector');

    tabSelectors.forEach(tabSelector => {
      const tabId = tabSelector.getAttribute('data-tab-id');
      const allTabSelectorImages = tabsWrapper.querySelectorAll(`.js-tabselector-image`);
      const allTabs = tabsWrapper.querySelectorAll(`.js-tab`);
      const linkedTabSelectorImage = tabsWrapper.querySelector(
        `.js-tabselector-image[data-tab-id="${tabId}"]`,
      );

      const linkedTab = tabsWrapper.querySelector(`.js-tab[data-tab-id="${tabId}"]`);

      if (window.location.hash) {
        const hashId = window.location.hash.split('#')[1];
        if (tabId === hashId) {
          setTabActive(
            tabSelector,
            tabSelectors,
            linkedTab,
            allTabs,
            allTabSelectorImages,
            linkedTabSelectorImage,
            tabId,
          );
        }
      }

      tabSelector.addEventListener('click', () => {
        setTabActive(
          tabSelector,
          tabSelectors,
          linkedTab,
          allTabs,
          allTabSelectorImages,
          linkedTabSelectorImage,
          tabId,
        );
      });
    });
  });
  const listener = () => {
    const { hash } = window.location;
    if (hash) {
      const hashWithoutBracket = hash.split('#')[1];
      if (hashWithoutBracket) {
        const tabLinkedToAnchor = document.querySelectorAll(
          `.js-tab-selector[data-tab-id="${hashWithoutBracket}"]`,
        );
        tabLinkedToAnchor.forEach(element => {
          element.click();
        });
      }
    }
  };
  window.addEventListener('popstate', listener);
}
